/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { StatoRes } from '../../models/stato-res';

export interface LuoghiControllerFindManyStati$Params {
  /**
   * Filter by active status (0 = inactive, 1 = active)
   */
  flagAttivo?: number;
}

export function luoghiControllerFindManyStati(
  http: HttpClient,
  rootUrl: string,
  params?: LuoghiControllerFindManyStati$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<Array<StatoRes>>> {
  const rb = new RequestBuilder(
    rootUrl,
    luoghiControllerFindManyStati.PATH,
    'get',
  );
  if (params) {
    rb.query('flagAttivo', params.flagAttivo, {});
  }

  return http
    .request(
      rb.build({ responseType: 'json', accept: 'application/json', context }),
    )
    .pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<StatoRes>>;
      }),
    );
}

luoghiControllerFindManyStati.PATH = '/luoghi/stati';
